import {Injectable} from '@angular/core';
import {AngularFireDatabase} from "@angular/fire/database";
import {Observable} from "rxjs";
import {Cpu} from "./cpu";
import {FieldsService} from "./fields.service";


@Injectable()
export class CpusService {

    constructor(private db: AngularFireDatabase) {
    }

    addCpu (dbPath: string, cpuKey: string, usesField: string, location: string, description: string, address: string,
            installationDate: string) {
      // TODO: split dbPath
      let s = dbPath.split("/");
      var field = usesField;
      if(!field.startsWith("-")) {
        field = s[1];
      }
      let cpu = {
        "location": location,
        "description": description,
        "address": address,
        "installationDate": installationDate,
        "maxOutput": -1,
        "simulate": false,
        "usesField": field,
        "rssi": "-?-",
        "network": "-?-",
        "lastSeen": "0",
        "lastBooted": "0"
      };

      if(cpuKey === "") {
        const cpus = this.db.list('fields/' + dbPath + '/cpus');
        let newkey = cpus.push(cpu);
        //console.log('CPU key: ' + newkey);
      } else {
        let path = 'fields/' + dbPath + '/cpus/';
        //console.log("Path to cpu: " + path);
        const cpuRef = this.db.object(path + cpuKey )
          .valueChanges()
          .subscribe(data => {
            if(data) {
              alert('Fout: CPU bestaat al bij dit veld!');
            } else {
              //console.log("Ik voeg een cpu toe");
              this.db.database.ref(path).child(cpuKey).set(cpu);
            }
        });
      }
    }

    updateCpu(dbPath: string, location: string, description: string, address: string, installationDate: string) {
        let cpu = {
            "location": location,
            "description": description,
            "address": address,
            "installationDate": installationDate
        };

        this.db.object(FieldsService.fieldsPath + dbPath).update(cpu);
    }

    setCCID(dbPath: string, ccidValue: string) {
      this.db.database.ref(FieldsService.fieldsPath + dbPath).child("address").set(ccidValue);
    }

}
